import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { FaPhoneAlt, FaEnvelope, FaGlobe, FaLinkedin, FaFacebook, FaInstagram } from 'react-icons/fa';

const BusinessCard = () => {
  return (
    <Container fluid className="p-4" style={{ backgroundColor: '#f4f4f4' }}>
      <Row className="bg-white rounded overflow-hidden" style={{ maxWidth: '814px', margin: 'auto' }}>
        <Col md={4} className="text-center p-4 position-relative">
          <img src="/path/to/image.jpg" alt="Profile" className="rounded-circle" style={{ width: '120px', height: '120px' }} />
          <div className="position-absolute" style={{ bottom: '-20px', left: '50%', transform: 'translateX(-50%)', backgroundColor: '#009e60', borderRadius: '50%', width: '50px', height: '50px' }}>
            {/* <FaCheckCircle className="text-white" size={30} style={{ margin: '10px' }} /> */}
          </div>
        </Col>
        <Col md={8} className="p-4">
          <h3 className="fw-bold">Kavin Kumar S</h3>
          <p className="text-muted">Strategic Growth Executive</p>
          <div className="d-flex align-items-center mb-2">
            <FaPhoneAlt className="text-success me-2" />
            <span>+91 95009 44452</span>
          </div>
          <div className="d-flex align-items-center mb-4">
            <FaEnvelope className="text-success me-2" />
            <span>kavin@fittex.io</span>
          </div>
          <h5 className="text-success">FITTex</h5>
          <p>Revolutionizing Apparel and Textile <span className="fw-bold">Business Efficiency.</span></p>
        </Col>
      </Row>
      <Row className="bg-success text-white text-center py-2 mt-3 rounded-bottom">
        <Col>
          <FaGlobe className="me-2" /> www.fittex.io
        </Col>
        <Col>
          <FaLinkedin />
        </Col>
        <Col>
          <FaFacebook />
        </Col>
        <Col>
          <FaInstagram />
        </Col>
      </Row>
    </Container>
  );
};

export default BusinessCard;
